import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MailerService } from '../services/mailer.service';
import { MailAttachment, Recipient } from '../models/mail.models';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-mail-compose',
  templateUrl: './mail-compose.component.html',
  styleUrls: ['./mail-compose.component.scss']
})
export class MailComposeComponent implements OnInit {

  @ViewChild('bodyEditor', { static: true }) bodyEditor: ElementRef<HTMLDivElement>;
  @ViewChild('fileInput', { static: true }) fileInput: ElementRef<HTMLInputElement>;
  @ViewChild('excelInput', { static: true }) excelInput: ElementRef<HTMLInputElement>;
  @ViewChild('bodyImageInput', { static: true }) bodyImageInput: ElementRef<HTMLInputElement>;

  subject = '';
  senderName = 'RedLeaf Softwares & Services LLP';
  senderTag = 'Marketing';
  bodyHtml = '';
  lastImportSummary: any;
  // templates = environment.emailjs.templates;
  // selectedTemplateId = this.templates[0]?.id || '';

  recipientDraft = '';
  recipients: Recipient[] = [];
  attachments: MailAttachment[] = [];

  isDragging = false;
  isSending = false;
  sendComplete = false;
  sentCount = 0;
  failedCount = 0;

  private emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  constructor(private mailer: MailerService, private http: HttpClient) { }
  ngOnInit(): void {
    // this.testApi(); 
  }

  onRecipientKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ',' || event.key === ' ') {
      event.preventDefault();
      this.commitRecipientDraft();
    } else if (event.key === 'Backspace' && !this.recipientDraft && this.recipients.length) {
      this.recipients.pop();
    }
  }

  onRecipientPaste(event: ClipboardEvent): void {
    const pasted = event.clipboardData?.getData('text');
    if ((pasted && pasted.includes(',')) || pasted?.includes('\n')) {
      event.preventDefault();
      pasted.split(/[,\n]/).map(e => e.trim()).filter(Boolean).forEach(e => this.addRecipient(e));
      this.recipientDraft = '';
    }
  }

  commitRecipientDraft(): void {
    const value = this.recipientDraft.trim().replace(/,$/, '');
    if (value) {
      this.addRecipient(value);
    }
    this.recipientDraft = '';
  }

  // addRecipient(email: string): void {
  //   const clean = email.trim().toLowerCase();
  //   if (!clean) { return; }
  //   if (this.recipients.some(r => r.email === clean)) { return; }
  //   this.recipients.push({ id: this.makeId(), email: clean, status: 'pending' });
  // }

  removeRecipient(id: string): void {
    this.recipients = this.recipients.filter(r => r.id !== id);
  }

  isValidEmail(email: string): boolean {
    return this.emailPattern.test(email);
  }

  get invalidRecipientCount(): number {
    return this.recipients.filter(r => !this.isValidEmail(r.email)).length;
  }

  // editorr 

  exec(command: string, value?: string): void {
    document.execCommand(command, false, value);
    this.bodyEditor.nativeElement.focus();
    this.syncBody();
  }

  syncBody(): void {
    this.bodyHtml = this.sanitizeHtml(this.bodyEditor.nativeElement.innerHTML);
    const stillHasImage = !!this.bodyEditor.nativeElement.querySelector('img');
    if (!stillHasImage) {
      this.bodyImageFile = null;
    }
  }

  onBodyPaste(event: ClipboardEvent): void {
    // Always paste as plain text — this is what strips out all the
    // invisible wrapper divs, inline styles, and tracking attributes that
    // come along when copying from Google Search, Gmail, Word, etc.
    event.preventDefault();
    const plainText = event.clipboardData?.getData('text/plain') ?? '';
    document.execCommand('insertText', false, plainText);
    this.syncBody();
  }

  get bodyIsEmpty(): boolean {
    return !this.bodyHtml || this.bodyHtml === '<br>';
  }

  // ---------- One inline image in the message (local preview only until send) ----------

  triggerBodyImageDialog(): void {
    this.bodyImageInput.nativeElement.click();
  }

  bodyImageFile: File | null = null;
  // onBodyImageSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   const file = input.files && input.files[0];
  //   if (!file) { return; }

  //   // Remove any previously inserted image first — only one is supported.
  //   const existing = this.bodyEditor.nativeElement.querySelector('img');
  //   if (existing) { existing.remove(); }

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.bodyEditor.nativeElement.focus();
  //     document.execCommand('insertHTML', false, `<img src="${reader.result}" style="max-width:100%;">`);
  //     this.syncBody();
  //     this.bodyImageFile = file; // ← track that an image is now present
  //   };
  //   reader.readAsDataURL(file);
  //   input.value = '';
  // }
  // onBodyImageSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   const file = input.files && input.files[0];
  //   input.value = ''; // allow re-selecting the same file later
  //   if (!file) { return; }

  //   if (!file.type.startsWith('image/')) {
  //     this.showToast('Only image files are allowed.');
  //     return;
  //   }

  //   const MAX_BYTES = 5 * 1024 * 1024; // 5MB
  //   if (file.size > MAX_BYTES) {
  //     this.showToast(`Image is too large (${this.formatSize(file.size)}). Max size is 5 MB.`);
  //     return;
  //   }

  //   // Remove any previously inserted image first — only one is supported.
  //   const existing = this.bodyEditor.nativeElement.querySelector('img');
  //   if (existing) { existing.remove(); }

  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.bodyEditor.nativeElement.focus();
  //     // document.execCommand('insertHTML', false, `<img src="${reader.result}" style="max-width:100%;">`);
  //     document.execCommand('insertHTML', false,
  //       `<img src="${reader.result}" style="max-width:250px;height:auto;max-height:320px;object-fit:contain;display:block;">`);
  //     // this.syncBody();
  //     this.bodyImageFile = file;
  //   };
  //   reader.readAsDataURL(file);
  // }
  onBodyImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    input.value = '';

    if (!file) { return; }

    if (!file.type.startsWith('image/')) {
      this.showToast('Only image files are allowed.');
      return;
    }

    const MAX_BYTES = 5 * 1024 * 1024; // 5MB

    if (file.size > MAX_BYTES) {
      this.showToast(`Image is too large (${this.formatSize(file.size)}). Max size is 5 MB.`);
      return;
    }

    const img = new Image();

    img.onload = () => {

      const MAX_WIDTH = 600;
      const MAX_HEIGHT = 300;

      if (img.width > MAX_WIDTH || img.height > MAX_HEIGHT) {
        this.showToast(
          `Maximum allowed image size is ${MAX_WIDTH} × ${MAX_HEIGHT}px. Selected image is ${img.width} × ${img.height}px.`
        );
        return;
      }

      // Remove previous image
      const existing = this.bodyEditor.nativeElement.querySelector('img');
      if (existing) {
        existing.remove();
      }

      this.bodyEditor.nativeElement.focus();

      document.execCommand(
        'insertHTML',
        false,
        `<img src="${img.src}" style="max-width:250px;height:auto;max-height:320px;object-fit:contain;display:block;">`
      );

      this.bodyImageFile = file;
    };

    img.onerror = () => {
      this.showToast('Invalid image.');
    };

    const reader = new FileReader();

    reader.onload = () => {
      img.src = reader.result as string;
    };

    reader.readAsDataURL(file);
  }

  /**
   * Converts the single base64 <img> in the message (if any) into a
   * cid: reference, and returns the raw image bytes separately so they can
   * be sent as an inline MIME attachment — nothing ever touches server disk.
   */
  private extractInlineImage(html: string): { html: string; image: { cid: string; blob: Blob; filename: string } | null } {
    const container = document.createElement('div');
    container.innerHTML = html;
    const img = container.querySelector('img[src^="data:"]');

    if (!img) {
      return { html: container.innerHTML, image: null };
    }

    const src = img.getAttribute('src') || '';
    const match = src.match(/^data:(.+?);base64,(.*)$/);
    if (!match) {
      return { html: container.innerHTML, image: null };
    }

    const mime = match[1];
    const binary = atob(match[2]);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) { bytes[i] = binary.charCodeAt(i); }
    const blob = new Blob([bytes], { type: mime });

    const cid = `inline-image-${Date.now()}`;
    const ext = mime.split('/')[1] || 'png';
    img.setAttribute('src', `cid:${cid}`);

    return { html: container.innerHTML, image: { cid, blob, filename: `inline.${ext}` } };
  }

  private sanitizeHtml(html: string): string {
    const allowedTags = new Set(['B', 'STRONG', 'I', 'EM', 'U', 'UL', 'OL', 'LI', 'A', 'IMG', 'BR', 'DIV']);
    const container = document.createElement('div');
    container.innerHTML = html;

    const clean = (node: Node): void => {
      Array.from(node.childNodes).forEach(child => {
        if (child.nodeType !== Node.ELEMENT_NODE) { return; }
        const el = child as HTMLElement;
        if (!allowedTags.has(el.tagName)) {
          // Unwrap disallowed elements: keep their content, drop the tag
          while (el.firstChild) { node.insertBefore(el.firstChild, el); }
          node.removeChild(el);
          return;
        }
        Array.from(el.attributes).forEach(attr => {
          if (el.tagName === 'A' && attr.name === 'href') { return; }
          if (el.tagName === 'IMG' && (attr.name === 'src' || attr.name === 'style')) { return; }
          el.removeAttribute(attr.name);
        });
        clean(el);
      });
    };

    clean(container);
    // this.capPreviewImages();
    return container.innerHTML;
  }

  // Call this right after any point where bodyHtml changes for preview purposes
  private capPreviewImages(): void {
    setTimeout(() => {
      document.querySelectorAll('.inbox-card__body img').forEach((img: HTMLElement) => {
        img.style.setProperty('max-width', '500px', 'important');
        img.style.setProperty('width', '100%', 'important');
      });
    });
  }
  //  Attachments 

  triggerFileDialog(): void {
    this.fileInput.nativeElement.click();
  }

  onFilesSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addFiles(input.files);
      input.value = '';
    }
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;
    if (event.dataTransfer?.files) {
      this.addFiles(event.dataTransfer.files);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(): void {
    this.isDragging = false;
  }

  addFiles(fileList: FileList): void {
    Array.from(fileList).forEach(file => {
      this.attachments.push({
        id: this.makeId(),
        file,
        name: file.name,
        sizeLabel: this.formatSize(file.size)
      });
    });
  }

  removeAttachment(id: string): void {
    this.attachments = this.attachments.filter(a => a.id !== id);
  }

  formatSize(bytes: number): string {
    if (bytes < 1024) { return `${bytes} B`; }
    if (bytes < 1024 * 1024) { return `${(bytes / 1024).toFixed(1)} KB`; }
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  }

  // ---------- Sending ----------

  get canSend(): boolean {
    return this.subject.trim().length > 0
      && !this.bodyIsEmpty
      && this.recipients.length > 0
      && this.invalidRecipientCount === 0
      // && !!this.selectedTemplateId
      && !this.isSending;
  }

  send(): void {
    if (!this.canSend) { return; }

    this.isSending = true;
    this.sendComplete = false;
    this.sentCount = 0;
    this.failedCount = 0;
    this.recipients.forEach(r => { r.status = 'sending'; r.errorMessage = undefined; });

    // const payload = {
    //   templateId: this.selectedTemplateId,
    //   subject: this.subject,
    //   bodyHtml: this.bodyHtml,
    //   recipients: this.recipients.map(r => r.email),
    //   attachments: this.attachments.map(a => a.file)
    // };

    const { html: bodyForSending, image: inlineImage } = this.extractInlineImage(this.bodyHtml);

    const payload = {
      // templateId: this.selectedTemplateId,
      subject: this.subject,
      bodyHtml: bodyForSending,
      recipients: this.recipients.map(r => ({ email: r.email, name: r.name })), // now objects, not just strings
      attachments: this.attachments.map(a => a.file),
      inlineImage: inlineImage || undefined
    };

    this.mailer.sendCampaign(payload).subscribe({
      next: result => {
        const target = this.recipients.find(r => r.email === result.recipient);
        if (target) {
          target.status = result.success ? 'sent' : 'failed';
          target.errorMessage = result.errorMessage;
          result.success ? this.sentCount++ : this.failedCount++;
        }
      },
      complete: () => {
        this.isSending = false;
        this.sendComplete = true;
      }
    });
  }

  // send(): void {
  //   if (!this.canSend) { return; }

  //   this.isSending = true;
  //   this.sendComplete = false;
  //   this.sentCount = 0;
  //   this.failedCount = 0;
  //   this.recipients.forEach(r => { r.status = 'sending'; r.errorMessage = undefined; });

  //   // Extract plain text from HTML content
  //   const plainText = this.extractPlainText(this.bodyHtml);

  //   const payload = {
  //     templateId: this.selectedTemplateId,
  //     subject: this.subject,
  //     bodyHtml: plainText, // Send plain text instead
  //     recipients: this.recipients.map(r => r.email),
  //     attachments: this.attachments.map(a => a.file)
  //   };

  //   this.mailer.sendCampaign(payload).subscribe({
  //     next: result => {
  //       const target = this.recipients.find(r => r.email === result.recipient);
  //       if (target) {
  //         target.status = result.success ? 'sent' : 'failed';
  //         target.errorMessage = result.errorMessage;
  //         result.success ? this.sentCount++ : this.failedCount++;
  //       }
  //     },
  //     complete: () => {
  //       this.isSending = false;
  //       this.sendComplete = true;
  //     }
  //   });
  // }

  resetCampaign(): void {
    this.sendComplete = false;
    this.recipients.forEach(r => r.status = 'pending');
    this.sentCount = 0;
    this.failedCount = 0;
  }

  private makeId(): string {
    return Math.random().toString(36).slice(2, 10);
  }

  toastMessage: string | null = null;
  private toastTimer: any = null;
  private showToast(message: string): void {
    this.toastMessage = message;
    if (this.toastTimer) { clearTimeout(this.toastTimer); }
    this.toastTimer = setTimeout(() => { this.toastMessage = null; }, 4000);
  }

  // private extractPlainText(html: string): string {
  //   if (!html) return '';

  //   // Replace block-level tags with newlines
  //   let plainText = html
  //     .replace(/<\/?(?:div|p|br|h[1-6]|li|tr)[^>]*>/gi, '\n') // Convert block tags to newlines
  //     .replace(/<[^>]*>/g, '') // Remove all other HTML tags
  //     .replace(/&nbsp;/g, ' ')
  //     .replace(/&amp;/g, '&')
  //     .replace(/&lt;/g, '<')
  //     .replace(/&gt;/g, '>')
  //     .replace(/&quot;/g, '"')
  //     .replace(/&#39;/g, "'")
  //     .replace(/\n\s*\n/g, '\n\n') // Remove extra line breaks
  //     .trim();

  //   return plainText;
  // }

  onExcelSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) { return; }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const firstSheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[firstSheetName];

      // Convert sheet to an array of row objects using the header row as keys
      const rows: any[] = XLSX.utils.sheet_to_json(sheet, { defval: '' });

      let added = 0;
      let skipped = 0;

      rows.forEach(row => {
        // Match "Email" / "email" / "E-mail" etc. and "Name" / "name" flexibly
        const emailKey = Object.keys(row).find(k => k.toLowerCase().replace(/[\s-]/g, '').includes('email'));
        const nameKey = Object.keys(row).find(k => k.toLowerCase().includes('name'));

        const email = emailKey ? String(row[emailKey]).trim() : '';
        const name = nameKey ? String(row[nameKey]).trim() : '';

        if (email && this.isValidEmail(email)) {
          this.addRecipient(email, name);
          added++;
        } else if (email) {
          skipped++; // had something in the email column but it wasn't valid
        }
      });

      console.log(`Excel import: ${added} added, ${skipped} skipped (invalid email)`);
      input.value = ''; // reset so the same file can be re-selected later
    };

    reader.readAsArrayBuffer(file);
  }


  triggerExcelDialog(): void {
    this.excelInput.nativeElement.click();
  }
  addRecipient(email: string, name?: string): void {
    const clean = email.trim().toLowerCase();
    if (!clean) { return; }
    if (this.recipients.some(r => r.email === clean)) { return; }
    this.recipients.push({ id: this.makeId(), email: clean, name, status: 'pending' });
  }

}